var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.includeInTopMenu)?_c('SfCarousel',{staticClass:"topic-carousel bg-light",attrs:{"settings":{
    autoplay: 3000,
    hoverpause: true,
  }}},_vm._l((_vm.includeInTopMenu),function(item){return _c('SfCarouselItem',{key:item.Id,staticClass:"carousel__item"},[_c('router-link',{staticClass:"text-primary",attrs:{"to":("/p/" + (item.SeName))}},[_vm._v(_vm._s(item.Title))])],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }